export default __webpack_public_path__ + "static/media/Overcast.52ba9637.mp4";